(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        (function () {
            var mainMenu = document.querySelector('#mobileMainMenu');
            var openBtn = document.querySelector('.btn-header-main-menu');
            var header = document.querySelector('header');
            var headerScrollDistance = 70;
            var scrollFrameId = null;

            if (!mainMenu || !openBtn || !window.eventDispatcher || !header) {
                return;
            }

            var isElementVisible = function isElementVisible(element) {
                if (!element) {
                    return false;
                }

                if (typeof window.getComputedStyle !== 'function') {
                    return true;
                }

                var style = window.getComputedStyle(element);
                return style.display !== 'none' && style.visibility !== 'hidden';
            };

            var syncHeaderLayoutState = function syncHeaderLayoutState() {
                var topHeader = header.querySelector('.m-header');
                var navBar = header.querySelector('.nav-bar');
                var shortFindForm = header.querySelector('.short-find-form');
                var hasDoubleRow = isElementVisible(topHeader) && (isElementVisible(navBar) || isElementVisible(shortFindForm));
                header.classList.toggle('header-has-double-row', hasDoubleRow);
                updateHeaderScrollState();
            };

            var updateHeaderScrollState = function updateHeaderScrollState() {
                if (!header.classList.contains('header-has-double-row')) {
                    header.style.top = '0px';
                    header.classList.remove('header-scroll-down');
                    return;
                }

                var scrollElement = document.scrollingElement || document.documentElement;
                var scrollDistance = Math.min(headerScrollDistance, Math.max(1, scrollElement.scrollHeight - scrollElement.clientHeight));
                var scrollTop = Math.max(0, Math.min(window.scrollY || window.pageYOffset || 0, scrollDistance)) / scrollDistance * headerScrollDistance;
                var isHeaderCollapsed = scrollTop >= headerScrollDistance;

                header.style.top = "-" + scrollTop + "px";
                header.classList.toggle('header-scroll-down', isHeaderCollapsed);
            };

            var handleScroll = function handleScroll() {
                if (scrollFrameId !== null) {
                    return;
                }

                scrollFrameId = window.requestAnimationFrame(function () {
                    scrollFrameId = null;
                    updateHeaderScrollState();
                });
            };

            var closeMenu = function closeMenu() {
                if (!mainMenu.classList.contains('is-open')) {
                    return;
                }

                mainMenu.classList.remove('is-open');
                mainMenu.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('mobile-main-menu-open');
                openBtn.setAttribute('aria-expanded', 'false');

                mainMenu.querySelectorAll('[data-main-menu-toggle]').forEach(function (toggleButton) {
                    toggleButton.setAttribute('aria-expanded', 'false');
                });

                mainMenu.querySelectorAll('.mobile-main-menu__submenu').forEach(function (submenu) {
                    submenu.classList.remove('is-open');
                    submenu.style.maxHeight = '0px';
                });
            };

            var openMenu = function openMenu() {
                mainMenu.classList.add('is-open');
                mainMenu.setAttribute('aria-hidden', 'false');
                document.body.classList.add('mobile-main-menu-open');
                openBtn.setAttribute('aria-expanded', 'true');
            };

            var toggleSection = function toggleSection(event, targetElement) {
                event.preventDefault();

                var targetId = targetElement.dataset.target;
                if (!targetId) {
                    return;
                }

                var section = mainMenu.querySelector("#" + targetId);
                if (!section) {
                    return;
                }

                var shouldOpen = targetElement.getAttribute('aria-expanded') !== 'true';

                mainMenu.querySelectorAll('[data-main-menu-toggle]').forEach(function (toggleButton) {
                    if (toggleButton !== targetElement) {
                        toggleButton.setAttribute('aria-expanded', 'false');
                    }
                });

                mainMenu.querySelectorAll('.mobile-main-menu__submenu').forEach(function (submenu) {
                    if (submenu !== section) {
                        submenu.classList.remove('is-open');
                        submenu.style.maxHeight = '0px';
                    }
                });

                targetElement.setAttribute('aria-expanded', String(shouldOpen));
                section.classList.toggle('is-open', shouldOpen);
                section.style.maxHeight = shouldOpen ? section.scrollHeight + "px" : '0px';
            };

            window.eventDispatcher.addEvent('click', '.btn-header-main-menu', function () {
                if (mainMenu.classList.contains('is-open')) {
                    closeMenu();
                    return;
                }

                openMenu();
            });
            window.eventDispatcher.on('click', '[data-main-menu-toggle]', function (event, targetElement) {
                return toggleSection(event, targetElement);
            });
            window.eventDispatcher.on('click', 'a.mobile-main-menu__link, a.mobile-main-menu__submenu-item', function () {
                return closeMenu();
            });

            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    closeMenu();
                }
            });

            syncHeaderLayoutState();
            updateHeaderScrollState();
            window.addEventListener('scroll', handleScroll, { passive: true });
            window.addEventListener('resize', function () {
                syncHeaderLayoutState();
            });
        })();
    }, {}] }, {}, [1]);